export default __webpack_public_path__ + "logo06428afa.png";